import { render, staticRenderFns } from "./Wxhover.vue?vue&type=template&id=89813a0a&scoped=true"
import script from "./Wxhover.vue?vue&type=script&lang=js"
export * from "./Wxhover.vue?vue&type=script&lang=js"
import style0 from "./Wxhover.vue?vue&type=style&index=0&id=89813a0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89813a0a",
  null
  
)

export default component.exports